import { defaultState } from './state'

export default {
    reset: (state) => {
        Object.assign(state, defaultState())
    },
    params(state, payload) {
        state.params = Object.assign({}, state.params, payload)
    }
}
